import { AbilityBuilder, createMongoAbility, type MongoAbility } from '@casl/ability';
import { abilitiesPlugin } from '@casl/vue';

import { ROLE_CONFIG } from '@/config/role-config';

import type { UserRole } from '@/types/auth.types';
import type { App } from 'vue';

export type Action = 'manage' | 'create' | 'read' | 'update' | 'delete' | 'finish';
export type Subject = 'Project' | 'User' | 'SupervisorStats' | 'all';

export type AppAbility = MongoAbility<[Action, Subject]>;
export type AbilityCan = AbilityBuilder<AppAbility>['can'];

export function defineAbilityFor(role: UserRole | null, userId?: string): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (role) {
    ROLE_CONFIG[role].defineAbility(can, userId);
  }

  return build();
}

export const ability = defineAbilityFor(null);

export function installAbility(app: App): void {
  app.use(abilitiesPlugin, ability, { useGlobalProperties: true });
}
